import { useState } from 'react';

export const useExpandableStates = () => {
  const [expandedSkills, setExpandedSkills] = useState({});
  const [expandedComments, setExpandedComments] = useState({});
  const [expandedSegmentComments, setExpandedSegmentComments] = useState({});

  const toggleSkillExpand = (skillId) => {
    setExpandedSkills(prev => ({
      ...prev,
      [skillId]: !prev[skillId]
    }));
  };

  const toggleCommentsExpand = (skillId) => {
    setExpandedComments(prev => ({
      ...prev,
      [skillId]: !prev[skillId]
    }));
  };

  const toggleSegmentCommentsExpand = (segmentId) => {
    setExpandedSegmentComments(prev => ({
      ...prev,
      [segmentId]: !prev[segmentId]
    }));
  };

  return {
    expandedSkills,
    expandedComments,
    expandedSegmentComments,
    toggleSkillExpand,
    toggleCommentsExpand,
    toggleSegmentCommentsExpand
  };
}; 